import { getUrls } from "utils/urls";
import useApiWrapper from "./useApiWrapper";

const useWSMApi = () => {
  const { fetchWithAuth } = useApiWrapper();
  const URLS = getUrls();

  const sendLoginOTP = async (data: any) => {
    return await fetchWithAuth(URLS.SEND_OTP, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const validateLoginOTP = async (data: any) => {
    return await fetchWithAuth(URLS.VALIDATE_OTP, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const fetchUserProfile = async () => {
    return await fetchWithAuth(URLS.GET_USER_PROFILE, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const updateUserProfile = async (data: any) => {
    return await fetchWithAuth(URLS.UPDATE_USER_PROFILE, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const updateProfilePic = async (data: any) => {
    return await fetchWithAuth(URLS.UPDATE_PROFILE_PIC, {
      method: "POST",
      body: data,
    });
  };

  const fetchS3File = async (key: string) => {
    const encodedKey = encodeURIComponent(key);
    return await fetchWithAuth(URLS.GET_S3_FILE(encodedKey), {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchWSMSlots = async (data: any) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.GET_WSM_SLOTS}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchWSMSlotById = async (slotId: string) => {
    return await fetchWithAuth(URLS.GET_WSM_SLOT(slotId), {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchExclusiveSlot = async () => {
    return await fetchWithAuth(URLS.GET_EXCLUSIVE_SLOT, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchBulletinSlot = async () => {
    return await fetchWithAuth(URLS.GET_BULLETIN_SLOT, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchUserCredits = async () => {
    return await fetchWithAuth(URLS.GET_USER_CREDITS, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const reserveWSMSlot = async (slotData: any) => {
    return await fetchWithAuth(URLS.RESERVE_WSM_SLOT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(slotData),
    });
  };

  const cancelReservation = async (slotData: any) => {
    return await fetchWithAuth(URLS.CANCEL_RESERVATION, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(slotData),
    });
  };

  const fetchReservations = async () => {
    return await fetchWithAuth(URLS.GET_RESERVATIONS, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchAllReservations = async () => {
    return await fetchWithAuth(URLS.GET_ALL_RESERVATIONS, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchReservationBySlotId = async (slotId: string) => {
    return await fetchWithAuth(URLS.GET_SLOT_RESERVATION(slotId), {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchComingUpEvents = async () => {
    return await fetchWithAuth(URLS.GET_COMING_UP_SLOTS, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchMembershipList = async () => {
    return await fetchWithAuth(URLS.GET_MEMBERSHIP_LIST, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const createPayment = async (data: any) => {
    return await fetchWithAuth(URLS.CREATE_PAYMENT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const verifyPayment = async (data: any) => {
    return await fetchWithAuth(URLS.VERIFY_PAYMENT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  };

  const fetchCreditPlans = async () => {
    return await fetchWithAuth(URLS.GET_CREDIT_PLANS, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchPassesList = async () => {
    return await fetchWithAuth(URLS.GET_PASSES_LIST, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchPaymentHistory = async (data: any) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.GET_PAYMENT_HISTORY}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  return {
    sendLoginOTP,
    validateLoginOTP,
    fetchUserProfile,
    updateUserProfile,
    updateProfilePic,
    fetchS3File,
    fetchWSMSlots,
    fetchWSMSlotById,
    fetchExclusiveSlot,
    fetchBulletinSlot,
    fetchUserCredits,
    reserveWSMSlot,
    cancelReservation,
    fetchReservations,
    fetchAllReservations,
    fetchReservationBySlotId,
    fetchComingUpEvents,
    fetchMembershipList,
    createPayment,
    verifyPayment,
    fetchCreditPlans,
    fetchPassesList,
    fetchPaymentHistory,
  };
};

export default useWSMApi;
